import React, { useEffect, useState } from "react";
import { MdDelete, MdModeEditOutline } from "react-icons/md";
import "../../css/Admin-Courses/AdminCoursesCard.css";
import AdminEditCourses from "./AdminEditCourses";
import { toast } from "react-toastify";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";

const AdminCoursesCard = ({ data, fetchData,projectKey }) => {
  const [editProject, setEditProject] = useState(false);

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this Course?")) {
      try {
        await deleteDoc(doc(db, "courses", projectKey));
        toast.success("Course deleted successfully");
        fetchData();
      } catch (error) {
        toast.error("Failed to delete Course");
      }
    }
  };


  return (
    <div className="product-container">
      <div className="product-card">
        <div className="product-image-div">
          <img
            src={data.courseCertificates}
            alt={data.courseCertificates}
            className="product-image"
          />
        </div>
        <h1 className="product-name">{data.courseInstitute}</h1>
        <p className="product-description">{data.courseName}</p>
        <div className="product-buttons">
          

          <div className="edit-button" onClick={() => setEditProject(true)}>
            <MdModeEditOutline style={{fontSize:'1.5rem' }}/>
          </div>

          <div className="delete-button" onClick={handleDelete}>
            <MdDelete style={{ fontSize: "1.5rem" ,color:"white"}} />
          </div>

        </div>
      </div>

      {editProject && (
                <AdminEditCourses onClose={() => setEditProject(false)} productData={data} fetchData={fetchData} projectKey={projectKey}/>
            )}
    </div>
  );
};

export default AdminCoursesCard;
